/* eslint-disable react/jsx-handler-names */
import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    handleApplyFilter as handleApplyFilterAction,
    handleRemoveFilter as handleRemoveFilterAction,
    handleRemoveAllFilters as handleRemoveAllFiltersAction,
} from '../actions/search';
import {
    openCloseAnimatedDrawer as openCloseAnimatedDrawerAction,
    setFilterTypeToShow as setFilterTypeToShowAction,
} from '../actions/ui';

import {
    getSelectedFilterCount,
    getSelectedDate,
    getSelectedCategory,
    getSelectedFormat,
} from '../selectors/search';

// TODO replace this import with a dynamic one based on the bot request value
import FilterPanelDesktop from '../components/filterPanel/FilterPanelDesktop';

const FilterPanelMobile = loadable(() =>
    import(
        /* webpackPrefetch: true */ '../components/filterPanel/FilterPanelMobile'
    ),
);

import { CUSTOM_DATE } from '../constants';

import './SearchContainer.scss';

export class SearchBaseScreen extends React.PureComponent {
    static propTypes = {
        /**
         * Callback for when filters are applied
         */
        handleApplyFilter: PropTypes.func,
        /**
         * Callback for when filters are removed
         */
        handleRemoveFilter: PropTypes.func,
        /**
         * Type of individual filter to show in the filter panel
         * or '' if all filters must be shown
         */
        filterTypeToShow: PropTypes.string,
        /**
         * Boolean for if mobile filter panel should be displayed
         */
        isAnimatedDrawerOpen: PropTypes.bool,
    };

    _handleChange = (key, value, shouldUpdateRoute) => {
        const { handleApplyFilter, handleRemoveFilter } = this.props;

        if (value === 'all') {
            handleRemoveFilter({ [key]: true });
        } else {
            handleApplyFilter({ [key]: value }, {}, shouldUpdateRoute);
        }
    };

    _handleCustomDate = (startDate, endDate) => {
        const { handleApplyFilter } = this.props;

        handleApplyFilter({ dates: CUSTOM_DATE }, { startDate, endDate });
    };

    render() {
        const {
            selectedFilterCount,
            isAnimatedDrawerOpen,
            filterTypeToShow,
            openCloseAnimatedDrawer,
            selectedFilters,
            handleRemoveFilter,
            locationSlug,
            isBotRequest,
            handleRemoveAllFilters,
            setFilterTypeToShowAction,
        } = this.props;

        const SHARED_FILTER_PROPS = {
            selectedFilterCount: selectedFilterCount,
            onFilterChange: this._handleChange,
            onCustomDateChange: this._handleCustomDate,
        };

        return (
            <>
                <aside className="search-base-screen__filter-panel">
                    <FilterPanelDesktop
                        {...SHARED_FILTER_PROPS}
                        locationSlug={locationSlug}
                        isBotRequest={isBotRequest}
                        handleRemoveAllFilters={handleRemoveAllFilters}
                        handleRemoveFilter={handleRemoveFilter}
                        selectedFilters={selectedFilters}
                        filterTypeToShow={filterTypeToShow}
                        handleDrawerSelect={setFilterTypeToShowAction}
                    />
                </aside>
                {isAnimatedDrawerOpen && (
                    <div>
                        <FilterPanelMobile
                            {...SHARED_FILTER_PROPS}
                            handleRemoveFilter={handleRemoveFilter}
                            filterTypeToShow={filterTypeToShow}
                            openCloseAnimatedDrawer={openCloseAnimatedDrawer}
                            selectedFilters={selectedFilters}
                        />
                        {/* eslint-disable-next-line react/no-danger */}
                        <style
                            dangerouslySetInnerHTML={{
                                __html: `
                          .eds-structure {
                            position: fixed;
                            width: 100%;
                            height: 100%;
                          }
                        `,
                            }}
                        />
                    </div>
                )}
            </>
        );
    }
}

const _mapStateToProps = (state) => ({
    selectedFilterCount: getSelectedFilterCount(state),
    isAnimatedDrawerOpen: state.ui.isAnimatedDrawerOpen,
    filterTypeToShow: state.ui.filterTypeToShow,
    isBotRequest: state.app.isBotRequest,
    locationSlug: state.location.slug,

    //TODO Refactor Search selectors into proper
    //selectors leveraging reselect
    selectedFilters: {
        price: state.search.eventSearch.price,
        tags: getSelectedCategory(state.search.eventSearch.tags),
        format: getSelectedFormat(state.search.eventSearch.tags),
        dates: getSelectedDate(
            state.search.eventSearch.dates,
            state.search.eventSearch.dateRange,
        ),
        currencies:
            state.search.eventSearch.currencies.length > 0
                ? state.search.eventSearch.currencies[0]
                : '',
        languages:
            state.search.eventSearch.languages.length > 0
                ? state.search.eventSearch.languages
                : '',
    },
});

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleApplyFilter: (...args) =>
        dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleRemoveFilter: (...args) =>
        dispatch(handleRemoveFilterAction(ownProps.history, ...args)),
    handleRemoveAllFilters: (...args) =>
        dispatch(handleRemoveAllFiltersAction(ownProps.history, ...args)),
    openCloseAnimatedDrawer: (...args) =>
        dispatch(openCloseAnimatedDrawerAction(...args)),
    setFilterTypeToShowAction: (...args) =>
        dispatch(setFilterTypeToShowAction(...args)),
});

const enhance = compose(
    withRouter,
    connect(_mapStateToProps, _mapDispatchToProps),
);

export default enhance(SearchBaseScreen);
